import React from 'react';
import { Container, Header, Divider, Icon } from 'semantic-ui-react';
import * as baseHelper from '../../helper/base-helper';

import ProfileForm from '../forms/ProfileForm';


class Profile extends React.Component {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitCallback = this.submitCallback.bind(this);
    this.setState = this.setState.bind(this);

    this.state = {
      processing: false
    }

  }

  submitCallback(msgObj) {
    const {message} = msgObj;
    this.props.profileUpdater();
    this.setState({
      message: message,
      processing: false}
    );
  }

  handleSubmit(e, data) {
    e.preventDefault();

    // Only if user actually changed anything do we call the db.
    if (Object.keys(data).length) {
      this.setState({processing: true});
      // updating either the profile
        baseHelper.updateUserProfile(data, this.submitCallback);

      // only if user updated email info,
      // update their email (this triggers email)
        if(data.email)
        baseHelper.updateUserEmail(data.email, this.submitCallback);
    }
  }


  render() {
    return (
      <Container text>
        <Header as='h2'>
          <Icon name='settings' />
          <Header.Content>
            Profile
            <Header.Subheader>
              Manage your profile settings. Sorry, you can change only cosmetics for the moment.
            </Header.Subheader>
          </Header.Content>
        </Header>
        <Divider />
        <ProfileForm
          {...this.props.user}
          processing={this.state.processing}
          handleSubmit={this.handleSubmit}
          message={this.state.message} />
      </Container>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/protected/Profile.js